import ky, { KyInstance } from 'ky';

import { apiUrl } from '@/app/shared/constants/env';

export const kyInstance: KyInstance = ky.create({
  prefixUrl: apiUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
});
